import React, { useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { Spinner } from "reactstrap";
import PhoneInput from 'react-phone-input-2';
import { useMatch, useParams, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const AddEditStudent = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const isView = !!useMatch("/student/view/:id");
    const isEdit = !!useMatch("/student/edit/:id");
    const isCreate = !id;

    const [loading, setLoading] = useState(false);
    const [studentName, setStudentName] = useState("");
    const [parentName, setParentName] = useState("");
    const [address, setAddress] = useState("");
    const [instrument, setInstrument] = useState("Drums");
    const [emailAddress, setEmailAddress] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [contactNoError, setContactNoError] = useState("");
    const [alternateNumber, setAlternateNumber] = useState("");
    const [alternateNoError, setAlternateNoError] = useState("");
    const [password, setPassword] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [isLoginAllow, setIsLoginAllow] = useState(true);
    const [isAdvancePayment, setIsAdvancePayment] = useState(false);
    const [isAdvance, setIsAdvance] = useState(false);
    const [isPauseProfile, setIsPauseProfile] = useState(false);
    const [isGracePeriod, setIsGracePeriod] = useState(true);
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [dateOfBirthError, setDateOfBirthError] = useState("");
    const [totalAmount, setTotalAmount] = useState("");
    const [advanceAmount, setAdvanceAmount] = useState("");
    const [startDate, setStartDate] = useState("");
    const [startDateError, setStartDateError] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endDateError, setEndDateError] = useState("");
    const [institutionName, setInstitutionName] = useState("");
    const [institutionAddress, setInstitutionAddress] = useState("");
    const [selectedLessonPlan, setSelectedLessonPlan] = useState("");
    const [selectedDuration, setSelectedDuration] = useState("");
    const [selectedDay, setSelectedDay] = useState("");
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectedTime, setSelectedTime] = useState("");
    const [selectedSecondDay, setSelectedSecondDay] = useState("");
    const [selectedSecondTime, setSelectedSecondTime] = useState("");
    const [selectedAdvanceDuration, setSelectedAdvanceDuration] = useState("");
    const [startAdvanceDate, setStartAdvanceDate] = useState("");
    const [startAdvanceDateError, setStartAdvanceDateError] = useState("");
    const [endAdvanceDate, setEndAdvanceDate] = useState("");
    const [endAdvanceDateError, setEndAdvanceDateError] = useState("");
    const [startPauseDate, setStartPauseDate] = useState("");
    const [startPauseDateError, setStartPauseDateError] = useState("");
    const [endPauseDate, setEndPauseDate] = useState("");
    const [endPauseDateError, setEndPauseDateError] = useState("");
    const [selectedInstitutionType, setSelectedInstitutionType] = useState("");
    const [selectedTrinityExam, setSelectedTrinityExam] = useState("");
    const [selectedHeardFrom, setSelectedHeardFrom] = useState("");
    const [note, setNote] = useState("");
    const [pauseId, setPauseId] = useState(null);
    const [paymentId, setPaymentId] = useState(null);
    const [classId, setClassId] = useState(null);
    const [studentScheduleId1, setStudentScheduleId1] = useState(null);
    const [studentScheduleId2, setStudentScheduleId2] = useState(null);

    const token = localStorage.getItem('authToken');
    const user = JSON.parse(localStorage.getItem("authUser"));
    const loadDetails = useCallback(async () => {
        if (!id) return;

        try {
            const res = await fetch(`https://api.kunalsdrumclass.com/api/GetStudentById?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const json = await res.json();
            const item = json?.recordsets?.[0]?.[0];
            const item1 = json?.recordsets?.[1]?.[0];
            const item2 = json?.recordsets?.[1]?.[1];

            setPauseId(item.Pause_Id);
            setPaymentId(item.Payment_Id);
            setClassId(item.Student_Class_Id);
            setStudentName(item.Student_Name);
            setParentName(item.Parent_Name);
            setDateOfBirth(mysqlToDDMMYYYY(item.Date_Of_Birth));
            setStartDate(mysqlToDDMMYYYY(item.Start_Date));
            setEndDate(mysqlToDDMMYYYY(item.End_Date));
            setStartAdvanceDate(mysqlToDDMMYYYY(item.Advance_Start_Date));
            setEndAdvanceDate(mysqlToDDMMYYYY(item.Advance_End_Date));
            setStartPauseDate(mysqlToDDMMYYYY(item.Pause_Start_Date));
            setEndPauseDate(mysqlToDDMMYYYY(item.Pause_End_Date));
            setContactNumber(item.Contact_Number);
            setAlternateNumber(item.Alternate_Number);
            setEmailAddress(item.Email_Address);
            setNote(item.Note);
            setAddress(item.Address);
            setPassword(item.Password);
            setSelectedLessonPlan(item.Lesson_Plan);
            setSelectedDuration(item.Class_Duration === 1 ? "1" : item.Class_Duration === 3 ? "3" : "");
            setTotalAmount(item.Total_Amount);
            setAdvanceAmount(item.Advance_Amount);
            setSelectedInstitutionType(item.Institution_Type);
            setInstitutionName(item.Institution_Name);
            setInstitutionAddress(item.Institution_Address);
            setSelectedTrinityExam(item.Trinity_Exam);
            setSelectedHeardFrom(item.Heard_From);
            setIsActive(item.IsActive);
            setIsLoginAllow(item.LoginAllow);
            if (item.Advance_Amount && parseFloat(item.Advance_Amount) > 0) {
                setIsAdvancePayment(true);
                setIsAdvance(true);
                setSelectedAdvanceDuration(item.Advance_Duration_Months === 1 ? "1" : item.Advance_Duration_Months === 3 ? "3" : "");
            } else {
                setStartAdvanceDate("");
                setEndAdvanceDate("");
                setAdvanceAmount("");
                setSelectedAdvanceDuration(null);
            }
            if (item.Pause_Id) {
                setIsPauseProfile(true);
            }
            if (item.Grace_Period_Days === 0) {
                setIsGracePeriod(false);
            }
            setStudentScheduleId1(item1.Schedule_Id);
            setSelectedDay(item1.Day_Of_Week);
            setSelectedTime(item1.Time);
            if (item.Lesson_Plan === "Twice a week") {
                setStudentScheduleId2(item2.Schedule_Id);
                setSelectedSecondDay(item2.Day_Of_Week);
                setSelectedSecondTime(item2.Time);
            }
        } catch (err) {
            console.error(err);
        }
    }, [id]);

    useEffect(() => {
        if (id) loadDetails();
    }, [id, loadDetails]);

    useEffect(() => {
        if (!selectedDay) return;

        const fetchData = async () => {
            try {
                const res = await fetch(`https://api.kunalsdrumclass.com/api/GetBatchSlotsByDay?day=${selectedDay}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const json = await res.json();
                setTimeSlots(json?.recordsets?.[0] || []);
            } catch (error) {
                console.error("API error:", error);
            }
        };

        fetchData();
    }, [selectedDay]);


    const mysqlToDDMMYYYY = (dateStr) => {
        if (!dateStr) return "";

        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
    };

    const formatIndianNumber = (value) => {
        const num = value.replace(/\D/g, "");
        let formatted = "+91 ";

        if (num.length > 2) {
            const mobile = num.slice(2);
            if (mobile.length <= 5) {
                formatted += mobile;
            } else {
                formatted += mobile.slice(0, 5) + "-" + mobile.slice(5, 10);
            }
        }
        return formatted.trim();
    };

    const handlePhoneChange1 = (value) => {
        const formatted = formatIndianNumber(value);
        setContactNumber(formatted);

        if (formatted) {
            setContactNoError("");
        }
    };

    const handlePhoneChange2 = (value) => {
        const formatted = formatIndianNumber(value);
        setAlternateNumber(formatted);

        if (formatted) {
            setAlternateNoError("");
        }
    };

    const handleSave = async () => {
        setContactNoError("");
        setAlternateNoError("");
        setDateOfBirthError("");
        setStartDateError("");
        setEndDateError("");
        setStartAdvanceDateError("");
        setEndAdvanceDateError("");
        setStartPauseDateError("");
        setEndPauseDateError("");
        try {
            const contactNoInvalid = contactNumber === "" || contactNumber === "+91";
            const alternateNoInvalid = alternateNumber === "" || alternateNumber === "+91";
            const dateOfBirthInvalid = !dateOfBirth;
            const startDateInvalid = !startDate;
            const endDateInvalid = !endDate;

            if (contactNoInvalid) setContactNoError("Please fill in this field.");
            if (alternateNoInvalid) setAlternateNoError("Please fill in this field.");
            if (dateOfBirthInvalid) setDateOfBirthError("Please fill in this field.");
            if (startDateInvalid) setStartDateError("Please fill in this field.");
            if (endDateInvalid) setEndDateError("Please fill in this field.");

            if (contactNoInvalid || alternateNoInvalid || dateOfBirthInvalid || startDateInvalid || endDateInvalid) {
                setLoading(false);
                return;
            }

            if (isAdvancePayment) {
                if (!startAdvanceDate && !endAdvanceDate) {
                    setStartAdvanceDateError("Please fill in this field.");
                    setEndAdvanceDateError("Please fill in this field.");
                    setLoading(false);
                    return;
                }

                if (!startAdvanceDate) {
                    setStartAdvanceDateError("Please fill in this field.");
                    setLoading(false);
                    return;
                }

                if (!endAdvanceDate) {
                    setEndAdvanceDateError("Please fill in this field.");
                    setLoading(false);
                    return;
                }
            }

            if (isPauseProfile) {
                if (!startPauseDate && !endPauseDate) {
                    setStartPauseDateError("Please fill in this field.");
                    setEndPauseDateError("Please fill in this field.");
                    setLoading(false);
                    return;
                }

                if (!startPauseDate) {
                    setStartPauseDateError("Please fill in this field.");
                    setLoading(false);
                    return;
                }

                if (!endPauseDate) {
                    setEndPauseDateError("Please fill in this field.");
                    setLoading(false);
                    return;
                }
            }

            const [d, m, y] = dateOfBirth.split("-");
            const mysqlDate = `${y}-${m}-${d}`;

            setLoading(true);

            const payload1 = {
                id: isEdit ? id : 0,
                studentName: studentName,
                parentName: parentName,
                emailAddress: emailAddress,
                password: password,
                dateOfBirth: mysqlDate,
                contactNumber: contactNumber,
                alternateNumber: alternateNumber,
                address: address,
                instrument: instrument,
                lessonPlan: selectedLessonPlan,
                institutionType: selectedInstitutionType,
                institutionName: institutionName,
                institutionAddress: institutionAddress,
                trinityExam: selectedTrinityExam,
                heardFrom: selectedHeardFrom,
                loginAllow: isLoginAllow,
                userId: user.Id,
                isActive: isActive
            };

            const res1 = await fetch(`https://api.kunalsdrumclass.com/api/InsertUpdateStudent`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                body: JSON.stringify(payload1),
            });

            const res1Data = await res1.json();
            const status = res1Data?.recordsets?.[0]?.[0]?.Status;
            const studentId = res1Data?.recordsets?.[0]?.[0]?.Id;

            if (!isEdit && status === 0) {
                await Swal.fire({
                    title: "Duplicate Record",
                    text: `student record already exists with this email!`,
                    icon: "warning",
                    customClass: {
                        popup: "swal2-material-ui",
                        confirmButton: "btn btn-sm rounded-8 btn-warning",
                    },
                });
                return;
            }

            if (isPauseProfile) {
                const [d, m, y] = startPauseDate.split("-");
                const [dd, mm, yy] = endPauseDate.split("-");
                const mysqlDate1 = `${y}-${m}-${d}`;
                const mysqlDate2 = `${yy}-${mm}-${dd}`;

                const payload4 = {
                    ids: pauseId ? pauseId : 0,
                    studentId: studentId,
                    pauseStartDate: mysqlDate1,
                    pauseEndDate: mysqlDate2,
                    note: note,
                    createdBy: user.Id
                };
                await fetch(`https://api.kunalsdrumclass.com/api/InsertStudentPause`, {
                    method: "POST",
                    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                    body: JSON.stringify(payload4),
                });
            }

            if (studentId) {
                const [d, m, y] = startDate.split("-");
                const [dd, mm, yy] = endDate.split("-");
                const mysqlDate1 = `${y}-${m}-${d}`;
                const mysqlDate2 = `${yy}-${mm}-${dd}`;

                const payload2 = {
                    ids: classId ? classId : 0,
                    studentId: studentId,
                    classDuration: selectedDuration,
                    lessonPlan: selectedLessonPlan,
                    startDate: mysqlDate1,
                    endDate: mysqlDate2,
                    gracePeriod: isGracePeriod ? 15 : 0,
                    createdBy: user.Id
                };
                const res2 = await fetch(`https://api.kunalsdrumclass.com/api/InsertStudentClass`, {
                    method: "POST",
                    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                    body: JSON.stringify(payload2),
                });

                const res2Data = await res2.json();
                const studentClassId = res2Data?.recordsets?.[0]?.[0]?.Id;

                if (studentClassId) {
                    if (selectedLessonPlan === "Twice a week") {
                        const [d, m, y] = startDate.split("-");
                        const [dd, mm, yy] = endDate.split("-");
                        const mysqlDate1 = `${y}-${m}-${d}`;
                        const mysqlDate2 = `${yy}-${mm}-${dd}`;

                        const payload3 = {
                            ids: studentScheduleId1 ? studentScheduleId1 : 0,
                            studentClassId: studentClassId,
                            dayOfWeek: selectedDay,
                            time: selectedTime,
                            startDate: mysqlDate1,
                            endDate: mysqlDate2,
                            createdBy: user.Id
                        };
                        await fetch(`https://api.kunalsdrumclass.com/api/InsertStudentClassSchedule`, {
                            method: "POST",
                            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                            body: JSON.stringify(payload3),
                        });

                        const payload4 = {
                            ids: studentScheduleId2 ? studentScheduleId2 : 0,
                            studentClassId: studentClassId,
                            dayOfWeek: selectedSecondDay,
                            time: selectedSecondTime,
                            startDate: mysqlDate1,
                            endDate: mysqlDate2,
                            createdBy: user.Id
                        };
                        await fetch(`https://api.kunalsdrumclass.com/api/InsertStudentClassSchedule`, {
                            method: "POST",
                            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                            body: JSON.stringify(payload4),
                        });
                    } else {
                        const [d, m, y] = startDate.split("-");
                        const [dd, mm, yy] = endDate.split("-");
                        const mysqlDate1 = `${y}-${m}-${d}`;
                        const mysqlDate2 = `${yy}-${mm}-${dd}`;

                        const payload3 = {
                            ids: studentScheduleId1 ? studentScheduleId1 : 0,
                            studentClassId: studentClassId,
                            dayOfWeek: selectedDay,
                            time: selectedTime,
                            startDate: mysqlDate1,
                            endDate: mysqlDate2,
                            createdBy: user.Id
                        };
                        await fetch(`https://api.kunalsdrumclass.com/api/InsertStudentClassSchedule`, {
                            method: "POST",
                            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                            body: JSON.stringify(payload3),
                        });
                    }

                    const [d, m, y] = startAdvanceDate.split("-");
                    const [dd, mm, yy] = endAdvanceDate.split("-");
                    const mysqlDate1 = `${y}-${m}-${d}`;
                    const mysqlDate2 = `${yy}-${mm}-${dd}`;

                    const payload5 = {
                        ids: paymentId ? paymentId : 0,
                        studentId: studentId,
                        studentClassId: studentClassId,
                        totalAmount: totalAmount,
                        advanceAmount: isAdvancePayment ? advanceAmount : null,
                        advanceStartDate: isAdvancePayment ? mysqlDate1 : null,
                        advanceEndDate: isAdvancePayment ? mysqlDate2 : null,
                        advanceDurationMonths: isAdvancePayment ? selectedAdvanceDuration : null,
                        createdBy: user.Id
                    };
                    await fetch(`https://api.kunalsdrumclass.com/api/InsertStudentPayment`, {
                        method: "POST",
                        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                        body: JSON.stringify(payload5),
                    });
                }
            }
            await Swal.fire({
                title: "Success!",
                text: isEdit ? `student updated successfully!` : `student created successfully!`,
                icon: "success",
                customClass: {
                    popup: "swal2-material-ui",
                    confirmButton: "btn btn-sm rounded-8 btn-primary",
                },
            });

            navigate(-1);
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Something went wrong while saving student", "error");
        } finally {
            setLoading(false);
        }
    };

    const slotOptions = timeSlots.map(item => ({
        value: item.Batch_Time,
        label: item.Batch_Time,
        availableSlots: item.Available_Slots,
        isDisabled: item.Available_Slots === 0
    }));

    const lessonPlanOptions = [
        { value: "Once a week", label: "Once a week" },
        { value: "Twice a week", label: "Twice a week" }
    ];

    const durationOptions = [
        { value: "1", label: "1 Month" },
        { value: "3", label: "3 Month" }
    ];

    const dayOptions = [
        { value: "Monday", label: "Monday" },
        { value: "Tuesday", label: "Tuesday" },
        { value: "Wednesday", label: "Wednesday" },
        { value: "Thursday", label: "Thursday" },
        { value: "Friday", label: "Friday" },
        { value: "Saturday", label: "Saturday" },
        { value: "Sunday", label: "Sunday" }
    ];

    const institutionOptions = [
        { value: "School", label: "School" },
        { value: "College", label: "College" },
        { value: "Other", label: "Other" }
    ];

    const trinityExamOptions = [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" }
    ];

    const heardFromOptions = [
        { value: "Facebook", label: "Facebook" },
        { value: "Instagram", label: "Instagram" },
        { value: "Google Search", label: "Google Search" },
        { value: "Pamphlets/Posters", label: "Pamphlets/Posters" },
        { value: "Through Reference", label: "Through Reference" }
    ];

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title="Students"
                    breadcrumbItems={[
                        { title: "Students", link: "/students" },
                        { title: isCreate ? "Create Student" : isView ? "View Student" : "Edit Student" }
                    ]}
                />
            </div>

            <div className="container py-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="mb-0">
                        {isCreate && "Create Student"}
                        {isView && "View Student"}
                        {isEdit && "Edit Student"}
                    </h3>

                    <button
                        className="btn btn-secondary"
                        onClick={() => navigate(-1)}
                    >
                        Back to List
                    </button>
                </div>

                <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
                    {loading ? (
                        <div className="text-center my-4">
                            <Spinner color="primary" />
                        </div>
                    ) : (
                        <>
                            {/* Form */}
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 mb-30">
                                        <div className="form-contact">
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label>Student Name*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={studentName}
                                                            disabled={isView}
                                                            onChange={(e) => setStudentName(e.target.value)}
                                                            placeholder="Student Name"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label>Parent Name*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={parentName}
                                                            disabled={isView}
                                                            onChange={(e) => setParentName(e.target.value)}
                                                            placeholder="Parent Name"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <label>Date Of Birth*</label>
                                                    <div className="input-group">
                                                        <Flatpickr
                                                            className="form-control d-block"
                                                            placeholder="dd-mm-yyyy"
                                                            value={dateOfBirth}
                                                            disabled={isView}
                                                            options={{
                                                                dateFormat: "d-m-Y"
                                                            }}
                                                            onChange={(selectedDates, dateStr) => {
                                                                setDateOfBirth(dateStr);
                                                            }}
                                                            required
                                                        />
                                                        <div className="input-group-append">
                                                            <span className="input-group-text">
                                                                <i className="mdi mdi-calendar" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {dateOfBirthError && <p className="text-danger">{dateOfBirthError}</p>}
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <div className="form-group no-phone-label">
                                                        <label>Contact Number*</label>
                                                        <PhoneInput country={'in'} placeholder="Contact Number *" disabled={isView} value={contactNumber || ""} inputClass="form-control phone"
                                                            inputStyle={{
                                                                width: "-webkit-fill-available"
                                                            }}
                                                            inputProps={{
                                                                name: "phone",
                                                                required: true
                                                            }}
                                                            onChange={handlePhoneChange1}
                                                        />
                                                    </div>
                                                    {contactNoError && <p className="text-danger">{contactNoError}</p>}
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <div className="form-group no-phone-label">
                                                        <label>Alternate/Emergency Contact Number*</label>
                                                        <PhoneInput country={'in'} placeholder="Alternate/Emergency Contact Number *" disabled={isView} value={alternateNumber || ""} inputClass="form-control phone"
                                                            inputStyle={{
                                                                width: "-webkit-fill-available"
                                                            }}
                                                            inputProps={{
                                                                name: "phone",
                                                                required: true
                                                            }}
                                                            onChange={handlePhoneChange2}
                                                        />
                                                    </div>
                                                    {alternateNoError && <p className="text-danger">{alternateNoError}</p>}
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <div className="form-group">
                                                        <label>Complete Address*</label>
                                                        <textarea
                                                            className="form-control"
                                                            rows={3}
                                                            style={{ resize: "vertical" }}
                                                            value={address}
                                                            disabled={isView}
                                                            onChange={(e) => setAddress(e.target.value)}
                                                            placeholder="Complete Address"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label>Email*</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            value={emailAddress}
                                                            disabled={isView}
                                                            onChange={(e) => setEmailAddress(e.target.value.toLowerCase())}
                                                            placeholder="Email"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-4">
                                                    <label className="form-label">Password*</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="password"
                                                            disabled={isView}
                                                            className="form-control"
                                                            value={password || ""}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            placeholder="Password"
                                                            required
                                                        />
                                                        <span className="input-group-text">
                                                            <i className="fas fa-eye-slash"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <div className="form-group">
                                                        <label>Instrument</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={instrument}
                                                            disabled={true}
                                                            onChange={(e) => setInstrument(e.target.value)}
                                                            placeholder="Instrument"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <label>Lesson Plan*</label>
                                                    <Select
                                                        value={
                                                            lessonPlanOptions.find(
                                                                option => option.value === selectedLessonPlan
                                                            ) || null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            setSelectedLessonPlan(selectedOption ? selectedOption.value : "")
                                                        }
                                                        required
                                                        isClearable
                                                        isDisabled={isView}
                                                        options={lessonPlanOptions}
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Select Lesson Plan"
                                                    />
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <label>Duration*</label>
                                                    <Select
                                                        value={
                                                            durationOptions.find(
                                                                option => option.value === selectedDuration
                                                            ) || null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            setSelectedDuration(selectedOption ? selectedOption.value : "")
                                                        }
                                                        required
                                                        isClearable
                                                        isDisabled={isView}
                                                        options={durationOptions}
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Select Duration"
                                                    />
                                                </div>
                                                <div className="col-lg-12 mb-1">
                                                    <h3 className="card-title"><u>Once a week</u></h3>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label>Day*</label>
                                                    <Select
                                                        value={
                                                            dayOptions.find(
                                                                option => option.value === selectedDay
                                                            ) || null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            setSelectedDay(selectedOption ? selectedOption.value : "")
                                                        }
                                                        required
                                                        isClearable
                                                        isDisabled={isView}
                                                        options={dayOptions}
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Select Day"
                                                    />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label>Time*</label>
                                                    <Select
                                                        value={
                                                            slotOptions.find(
                                                                option => option.value === selectedTime
                                                            ) || null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            setSelectedTime(selectedOption ? selectedOption.value : "")
                                                        }
                                                        required
                                                        isClearable
                                                        isDisabled={isView}
                                                        options={slotOptions}
                                                        formatOptionLabel={(option, { context }) =>
                                                            context === "menu" ? (
                                                                option.availableSlots === 0
                                                                    ? `${option.label} (Full)`
                                                                    : `${option.label} (${option.availableSlots} slots left)`
                                                            ) : (
                                                                option.label
                                                            )
                                                        }
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Select Time"
                                                    />
                                                </div>
                                                {selectedLessonPlan === "Twice a week" && (
                                                    <>
                                                        <div className="col-lg-12 mb-1">
                                                            <h3 className="card-title"><u>Twice a week</u></h3>
                                                        </div>
                                                        <div className="col-lg-6 mb-3">
                                                            <label>Day*</label>
                                                            <Select
                                                                value={
                                                                    dayOptions.find(
                                                                        option => option.value === selectedSecondDay
                                                                    ) || null
                                                                }
                                                                onChange={(selectedOption) =>
                                                                    setSelectedSecondDay(selectedOption ? selectedOption.value : "")
                                                                }
                                                                required
                                                                isClearable
                                                                isDisabled={isView}
                                                                options={dayOptions}
                                                                classNamePrefix="select2-selection"
                                                                placeholder="Select Day"
                                                            />
                                                        </div>
                                                        <div className="col-lg-6 mb-3">
                                                            <label>Time*</label>
                                                            <Select
                                                                value={
                                                                    slotOptions.find(
                                                                        option => option.value === selectedSecondTime
                                                                    ) || null
                                                                }
                                                                onChange={(selectedOption) =>
                                                                    setSelectedSecondTime(selectedOption ? selectedOption.value : "")
                                                                }
                                                                required
                                                                isClearable
                                                                isDisabled={isView}
                                                                options={slotOptions}
                                                                formatOptionLabel={(option, { context }) =>
                                                                    context === "menu" ? (
                                                                        option.availableSlots === 0
                                                                            ? `${option.label} (Full)`
                                                                            : `${option.label} (${option.availableSlots} slots left)`
                                                                    ) : (
                                                                        option.label
                                                                    )
                                                                }
                                                                classNamePrefix="select2-selection"
                                                                placeholder="Select Time"
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                <div className="col-lg-4 mb-3">
                                                    <label>Start Date*</label>
                                                    <div className="input-group">
                                                        <Flatpickr
                                                            className="form-control d-block"
                                                            placeholder="dd-mm-yyyy"
                                                            value={startDate}
                                                            disabled={isView}
                                                            options={{
                                                                dateFormat: "d-m-Y",
                                                                minDate: id ? null : "today"
                                                            }}
                                                            onChange={(selectedDates, dateStr) => {
                                                                setStartDate(dateStr);
                                                            }}
                                                            required
                                                        />
                                                        <div className="input-group-append">
                                                            <span className="input-group-text">
                                                                <i className="mdi mdi-calendar" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {startDateError && <p className="text-danger">{startDateError}</p>}
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <label>End Date*</label>
                                                    <div className="input-group">
                                                        <Flatpickr
                                                            className="form-control d-block"
                                                            placeholder="dd-mm-yyyy"
                                                            value={endDate}
                                                            disabled={isView}
                                                            options={{
                                                                dateFormat: "d-m-Y",
                                                                minDate: startDate ? startDate : "today"
                                                            }}
                                                            onChange={(selectedDates, dateStr) => {
                                                                setEndDate(dateStr);
                                                            }}
                                                            required
                                                        />
                                                        <div className="input-group-append">
                                                            <span className="input-group-text">
                                                                <i className="mdi mdi-calendar" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {endDateError && <p className="text-danger">{endDateError}</p>}
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <div className="form-group">
                                                        <label>Total Amount*</label>
                                                        <input
                                                            type="number"
                                                            min={1}
                                                            className="form-control"
                                                            value={totalAmount}
                                                            disabled={isView}
                                                            onChange={(e) => setTotalAmount(e.target.value)}
                                                            placeholder="Total Amount"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <label>Institution Type</label>
                                                    <Select
                                                        value={
                                                            institutionOptions.find(
                                                                option => option.value === selectedInstitutionType
                                                            ) || null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            setSelectedInstitutionType(selectedOption ? selectedOption.value : "")
                                                        }
                                                        isClearable
                                                        isDisabled={isView}
                                                        options={institutionOptions}
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Select Institution Type"
                                                    />
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <div className="form-group">
                                                        <label>Institution Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={institutionName}
                                                            disabled={isView}
                                                            onChange={(e) => setInstitutionName(e.target.value)}
                                                            placeholder="Institution Name"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 mb-3">
                                                    <div className="form-group">
                                                        <label>Institution Address</label>
                                                        <textarea
                                                            className="form-control"
                                                            rows={3}
                                                            style={{ resize: "vertical" }}
                                                            value={institutionAddress}
                                                            disabled={isView}
                                                            onChange={(e) => setInstitutionAddress(e.target.value)}
                                                            placeholder="Institution Address"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label>Trinity Exam</label>
                                                    <Select
                                                        value={
                                                            trinityExamOptions.find(
                                                                option => option.value === selectedTrinityExam
                                                            ) || null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            setSelectedTrinityExam(selectedOption ? selectedOption.value : "")
                                                        }
                                                        isClearable
                                                        isDisabled={isView}
                                                        options={trinityExamOptions}
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Select Trinity Exam"
                                                    />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label>Heard From*</label>
                                                    <Select
                                                        value={
                                                            heardFromOptions.find(
                                                                option => option.value === selectedHeardFrom
                                                            ) || null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            setSelectedHeardFrom(selectedOption ? selectedOption.value : "")
                                                        }
                                                        required
                                                        isClearable
                                                        isDisabled={isView}
                                                        options={heardFromOptions}
                                                        classNamePrefix="select2-selection"
                                                        placeholder="Select Heard From"
                                                    />
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isAdvancePayment}
                                                        disabled={isView || isAdvance}
                                                        onChange={(e) => setIsAdvancePayment(e.target.checked)}
                                                    />
                                                    <label className="form-check-label">
                                                        Advance Payment?
                                                    </label>
                                                </div>
                                                {isAdvancePayment && (
                                                    <>
                                                        <div className="col-lg-6 mt-2 mb-3">
                                                            <label>Duration*</label>
                                                            <Select
                                                                value={
                                                                    durationOptions.find(
                                                                        option => option.value === selectedAdvanceDuration
                                                                    ) || null
                                                                }
                                                                onChange={(selectedOption) =>
                                                                    setSelectedAdvanceDuration(selectedOption ? selectedOption.value : "")
                                                                }
                                                                required
                                                                isClearable
                                                                isDisabled={isView}
                                                                options={durationOptions}
                                                                classNamePrefix="select2-selection"
                                                                placeholder="Select Duration"
                                                            />
                                                        </div>
                                                        <div className="col-lg-6 mt-2 mb-3">
                                                            <div className="form-group">
                                                                <label>Advance Amount*</label>
                                                                <input
                                                                    type="number"
                                                                    min={1}
                                                                    className="form-control"
                                                                    value={advanceAmount}
                                                                    disabled={isView}
                                                                    onChange={(e) => setAdvanceAmount(e.target.value)}
                                                                    placeholder="Advance Amount"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 mb-4">
                                                            <label>Start Date*</label>
                                                            <div className="input-group">
                                                                <Flatpickr
                                                                    className="form-control d-block"
                                                                    placeholder="dd-mm-yyyy"
                                                                    value={startAdvanceDate}
                                                                    disabled={isView}
                                                                    options={{
                                                                        dateFormat: "d-m-Y",
                                                                        minDate: id ? null : "today"
                                                                    }}
                                                                    onChange={(selectedDates, dateStr) => {
                                                                        setStartAdvanceDate(dateStr);
                                                                    }}
                                                                    required
                                                                />
                                                                <div className="input-group-append">
                                                                    <span className="input-group-text">
                                                                        <i className="mdi mdi-calendar" />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {startAdvanceDateError && <p className="text-danger">{startAdvanceDateError}</p>}
                                                        </div>
                                                        <div className="col-lg-6 mb-4">
                                                            <label>End Date*</label>
                                                            <div className="input-group">
                                                                <Flatpickr
                                                                    className="form-control d-block"
                                                                    placeholder="dd-mm-yyyy"
                                                                    value={endAdvanceDate}
                                                                    disabled={isView}
                                                                    options={{
                                                                        dateFormat: "d-m-Y",
                                                                        minDate: startAdvanceDate ? startAdvanceDate : "today"
                                                                    }}
                                                                    onChange={(selectedDates, dateStr) => {
                                                                        setEndAdvanceDate(dateStr);
                                                                    }}
                                                                    required
                                                                />
                                                                <div className="input-group-append">
                                                                    <span className="input-group-text">
                                                                        <i className="mdi mdi-calendar" />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {endAdvanceDateError && <p className="text-danger">{endAdvanceDateError}</p>}
                                                        </div>
                                                    </>
                                                )}
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isGracePeriod}
                                                        disabled={isView}
                                                        onChange={(e) => setIsGracePeriod(e.target.checked)}
                                                    />
                                                    <label className="form-check-label">
                                                        Grace Period(15 Days)?
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isPauseProfile}
                                                        disabled={isView || pauseId}
                                                        onChange={(e) => setIsPauseProfile(e.target.checked)}
                                                    />
                                                    <label className="form-check-label">
                                                        Pause Profile?
                                                    </label>
                                                </div>
                                                {isPauseProfile && (
                                                    <>
                                                        <div className="col-lg-6 mt-2 mb-3">
                                                            <label>Start Date*</label>
                                                            <div className="input-group">
                                                                <Flatpickr
                                                                    className="form-control d-block"
                                                                    placeholder="dd-mm-yyyy"
                                                                    value={startPauseDate}
                                                                    disabled={isView}
                                                                    options={{
                                                                        dateFormat: "d-m-Y",
                                                                        minDate: id ? null : "today"
                                                                    }}
                                                                    onChange={(selectedDates, dateStr) => {
                                                                        setStartPauseDate(dateStr);
                                                                    }}
                                                                    required
                                                                />
                                                                <div className="input-group-append">
                                                                    <span className="input-group-text">
                                                                        <i className="mdi mdi-calendar" />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {startPauseDateError && <p className="text-danger">{startPauseDateError}</p>}
                                                        </div>
                                                        <div className="col-lg-6 mt-2 mb-3">
                                                            <label>End Date*</label>
                                                            <div className="input-group">
                                                                <Flatpickr
                                                                    className="form-control d-block"
                                                                    placeholder="dd-mm-yyyy"
                                                                    value={endPauseDate}
                                                                    disabled={isView}
                                                                    options={{
                                                                        dateFormat: "d-m-Y",
                                                                        minDate: startPauseDate ? startPauseDate : "today"
                                                                    }}
                                                                    onChange={(selectedDates, dateStr) => {
                                                                        setEndPauseDate(dateStr);
                                                                    }}
                                                                    required
                                                                />
                                                                <div className="input-group-append">
                                                                    <span className="input-group-text">
                                                                        <i className="mdi mdi-calendar" />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {endPauseDateError && <p className="text-danger">{endPauseDateError}</p>}
                                                        </div>
                                                        <div className="col-lg-12 mb-4">
                                                            <div className="form-group">
                                                                <label>Note*</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    rows={3}
                                                                    style={{ resize: "vertical" }}
                                                                    value={note}
                                                                    disabled={isView}
                                                                    onChange={(e) => setNote(e.target.value)}
                                                                    placeholder="Note"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isActive}
                                                        disabled={isView}
                                                        onChange={(e) => setIsActive(e.target.checked)}
                                                    />
                                                    <label className="form-check-label">
                                                        Is Active?
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isLoginAllow}
                                                        disabled={isView}
                                                        onChange={(e) => setIsLoginAllow(e.target.checked)}
                                                    />
                                                    <label className="form-check-label">
                                                        Is Login Allow?
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Save/Cancel Button */}
                            {!isView && (
                                <div className="mt-3 d-flex gap-2 justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Cancel
                                    </button>

                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {isCreate ? "Save" : "Update"}
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </form>
            </div>
        </div>
    );
};

export default AddEditStudent;
